/* 🤖 this file was generated by script */
export const wiconArrowNarrowDown = {
  name: 'arrow_narrow_down',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m0 0l6-6m-6 6l-6-6"/></svg>`,
};
